// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "re-classnames/src/Cn.bs.js";
import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Atom_Text from "../../atom/Atom_Text.bs.js";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Css_Js_Core from "bs-css/src/Css_Js_Core.bs.js";
import * as Type_String from "../../../type/Type_String.bs.js";
import * as Particle_Color from "../../particle/Particle_Color.bs.js";

var wrapperRules = [
  CssJs.display("block"),
  CssJs.width(CssJs.pct(100)),
  CssJs.height(CssJs.pct(100))
];

var textRules = [Css_Js_Core.SVG.fill(CssJs.transparent)];

var clipRectRules = [
  Css_Js_Core.SVG.fill(Particle_Color.Css.color("White")),
  CssJs.transforms([
        CssJs.translate(CssJs.pct(0), CssJs.pct(0)),
        CssJs.rotate(CssJs.deg(0))
      ])
];

var wrapperClass = Belt_Option.map(Belt_Option.map(wrapperRules, (function (__x) {
            return Belt_Array.map(__x, (function (rule) {
                          var __x = [rule];
                          return CssJs.style(__x);
                        }));
          })), (function (__x) {
        return CssJs.merge(__x);
      }));

var textClass = Belt_Option.map(Belt_Option.map(textRules, (function (__x) {
            return Belt_Array.map(__x, (function (rule) {
                          var __x = [rule];
                          return CssJs.style(__x);
                        }));
          })), (function (__x) {
        return CssJs.merge(__x);
      }));

var clipRectClass = Belt_Option.map(Belt_Option.map(clipRectRules, (function (__x) {
            return Belt_Array.map(__x, (function (rule) {
                          var __x = [rule];
                          return CssJs.style(__x);
                        }));
          })), (function (__x) {
        return CssJs.merge(__x);
      }));

function Organism_Teaser_Animated_Title(Props) {
  var id = Props.id;
  var title = Props.title;
  var style = Props.style;
  var identifier = Props.identifier;
  var id$1 = Curry._1(Type_String.Teaser.Id.toString, id);
  if (title === undefined) {
    return null;
  }
  if (style === undefined) {
    return React.createElement(Atom_Text.ScreenreadersLabel.make, {
                children: title
              });
  }
  var tmp = {
    children: React.createElement("svg", {
          className: Cn.take(wrapperClass)
        }, React.createElement("symbol", {
              id: "s-text" + id$1 + ""
            }, React.createElement("text", {
                  dy: ".35em",
                  textAnchor: "middle",
                  x: "50%",
                  y: "50%"
                }, title)), React.createElement("clipPath", {
              id: "cp-text" + id$1 + ""
            }, React.createElement("text", {
                  dy: ".35em",
                  textAnchor: "middle",
                  x: "50%",
                  y: "50%"
                }, title)), React.createElement("g", {
              clipPath: "url(#cp-text" + id$1 + ")"
            }, React.createElement("rect", {
                  className: Cn.take(clipRectClass),
                  height: "100%",
                  width: "100%"
                })), React.createElement("use", {
              className: Cn.take(textClass),
              xlinkHref: "#s-text" + id$1 + ""
            })),
    id: id$1,
    kind: "h3",
    style: style
  };
  if (identifier !== undefined) {
    tmp.identifier = Caml_option.valFromOption(identifier);
  }
  return React.createElement(Atom_Text.make, tmp);
}

var make = Organism_Teaser_Animated_Title;

export {
  wrapperRules ,
  textRules ,
  clipRectRules ,
  wrapperClass ,
  textClass ,
  clipRectClass ,
  make ,
}
/* wrapperRules Not a pure module */
